import styled, {css} from 'styled-components';
import {DARK_MODE_BORDER_COLOR} from "../../constants/colorScheme";

const StyledContainer = styled.div`
    .hidden { display: none; }
        
    ${props => props.darkMode && css`
        .minus-icon {
            color: white;
        }
        
        .ant-select-arrow {
            color: white;
        }        
        
        .ant-btn {            
            border-color: ${DARK_MODE_BORDER_COLOR};
        }
   `} 
    
    .ant-breadcrumb-link a {
        color: ${props => props.primaryColor} !important;
        opacity: 0.7;
    }
`;

export default StyledContainer;